import React, { JSX } from 'react';
import { RaceRangerWordmarkImg } from '../components/branding/RaceRangerBrand';
import CyclingLoader from '../components/shared/CyclingLoader';

const LOGIN_LOADING_PHRASES = [
  'Signing you in with Cognito…',
  'Verifying your session…',
  'Connecting to Fleet Manager…',
];

function LoginLoadingScreen(): JSX.Element {
    return (
        <div
            className="h-screen flex items-center justify-center relative overflow-hidden"
            style={{ background: '#060d1a' }}
        >
            {/* Ambient glow blobs — mirrors LoginPage */}
            <div
                className="absolute pointer-events-none"
                style={{
                    top: '-20%', left: '-10%',
                    width: '70%', height: '70%',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)',
                    filter: 'blur(40px)',
                }}
            />
            <div
                className="absolute pointer-events-none"
                style={{
                    bottom: '-20%', right: '-10%',
                    width: '60%', height: '60%',
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)',
                    filter: 'blur(40px)',
                }}
            />

            <div
                className="absolute inset-0 pointer-events-none opacity-[0.025]"
                style={{
                    backgroundImage:
                        'linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)',
                    backgroundSize: '48px 48px',
                }}
            />

            {/* Card */}
            <div
                className="relative w-full max-w-[400px] mx-4 rounded-2xl p-8 flex flex-col items-center"
                style={{
                    background: 'rgba(15,25,41,0.85)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    border: '1px solid rgba(255,255,255,0.09)',
                    boxShadow: '0 24px 80px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
            >
                {/* Brand */}
                <div className="mb-5 flex w-full flex-col items-center px-2">
                    <RaceRangerWordmarkImg className="max-h-[4rem] w-auto max-w-[min(100%,380px)] sm:max-h-[4.5rem]" />
                </div>

                <p className="text-xs text-slate-400 mb-7 tracking-wide uppercase">Fleet Manager</p>

                <CyclingLoader phrases={LOGIN_LOADING_PHRASES} size="md" className="mb-3" />

                <p className="mt-6 text-[11px] text-slate-500 text-center">
                    Raceranger Ltd · Fleet Management System
                </p>
            </div>
        </div>
    );
}

export default LoginLoadingScreen;
